import EmployeeTokenModal from './EmployeeTokenModal';

export default EmployeeTokenModal;
